import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ListPropertyPipe } from './list-property.pipe';
import { StripHTMLPipe } from './striphtml.pipe';
import { TruncatePipe } from './truncate.pipe';
import { DateFormatPipe } from './date-format.pipe';
import { OrdinaPerRiferimentoPipe } from './ordina-per-riferimento.pipe';

@NgModule({
  declarations: [
    StripHTMLPipe,
    TruncatePipe,
    ListPropertyPipe,
    DateFormatPipe,
    OrdinaPerRiferimentoPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    StripHTMLPipe,
    TruncatePipe,
    ListPropertyPipe,
    DateFormatPipe,
    OrdinaPerRiferimentoPipe,
  ]
})
export class PipeModule {

  static forRoot(): ModuleWithProviders<PipeModule> {
    return {
      ngModule: PipeModule,
      providers: [],
    };
  }
}
